import React from 'react';
import { Col } from 'antd';
import { I18n } from '@aws-amplify/core';
import { CustomFormItem, CustomRow } from './styles';

interface ExistingPreventionMeasuresProps {
	existingPreventionMeasures: string;
}

export const ExistingPreventionMeasures: React.FC<ExistingPreventionMeasuresProps> = ({
	existingPreventionMeasures
}) => {
	return (
		<Col xs={24} sm={12} lg={24}>
			<CustomFormItem label={I18n.get('Existing prevention measures')} labelCol={{ span: 24 }}>
				<CustomRow>{existingPreventionMeasures}</CustomRow>
			</CustomFormItem>
		</Col>
	);
};
